// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"04dcde8f","64":"4cdf0bc6","181":"b59b331a","184":"5a5c1752","312":"5a19ed6a","484":"6bfd4490","508":"dc0d2b16","551":"79c0e2f7","629":"f4d7479e","776":"c7dc6db8","842":"41d5c0c1","851":"92d17a4a"}[chunkId] + ".chunk.js";
};